// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../api/client";

/**
 * Handles the return from Emergent Google Auth.
 * URL looks like: https://<origin>/dashboard#session_id=xxxx
 *
 * We extract the session_id, POST it to our backend to exchange for our JWT,
 * store the JWT in localStorage (same slot as password login), then hard-navigate
 * to /dashboard so AuthProvider re-hydrates cleanly.
 */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setError("Aucun identifiant de session Google trouvé.");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("token", res.data.access_token);
        // Clean the fragment from the URL to avoid re-processing on refresh
        window.history.replaceState(null, "", window.location.pathname);
        // Hard reload so AuthProvider picks up the fresh token
        window.location.href = "/dashboard";
      } catch (e) {
        const detail = e.response?.data?.detail || "Connexion Google impossible.";
        setError(detail);
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#faf7f0]">
      <div className="max-w-md w-full mx-6 text-center">
        {error ? (
          <div className="glass-card rounded-2xl p-8" data-testid="google-auth-error">
            <div className="w-14 h-14 mx-auto rounded-full bg-red-100 text-red-600 flex items-center justify-center mb-4">
              <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M4.93 19h14.14a2 2 0 001.75-2.98l-7.07-12.25a2 2 0 00-3.5 0L3.18 16.02A2 2 0 004.93 19z" />
              </svg>
            </div>
            <h2 className="text-lg font-bold text-gray-900 mb-2" style={{ fontFamily: "Outfit, sans-serif" }}>
              Connexion Google refusée
            </h2>
            <p className="text-sm text-gray-600 mb-5">{error}</p>
            <button
              onClick={() => navigate("/login")}
              className="btn-primary text-sm px-5 py-2"
              data-testid="google-auth-back-btn"
            >
              Retour à la connexion
            </button>
          </div>
        ) : (
          <div data-testid="google-auth-loading">
            <div className="w-12 h-12 mx-auto border-4 border-amber-500 border-t-transparent rounded-full animate-spin mb-4" />
            <p className="text-sm text-gray-600">Connexion Google en cours…</p>
          </div>
        )}
      </div>
    </div>
  );
}
